/* eslint-disable default-param-last */
import { fromJS } from 'immutable'

import {
  LOAD_SLIDER_SUCCESS,
  LOAD_SLIDER_ERROR,
  TRANSITION_END,
  NEXT_SLIDE,
  PREVIOUS_SLIDE,
  LOAD_COLLECT_HOME_SUCCESS,
  LOAD_COLLECT_HOME_ERROR,
  GO_TO_SLIDE,
} from './constants'

const initialState = fromJS({
  slider: {
    currentSlide: 0,
    previousSlide: null,
    nextSlide: null,
    loaded: false,
    transitioning: false,
    slides: [],
  },
  home: {},
})

function homePageReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_SLIDER_SUCCESS: {
      const slides = fromJS(action.data)

      return state
        .setIn(['slider', 'slides'], slides)
        .setIn(['slider', 'loaded'], true)
        .setIn(['slider', 'previousSlide'], slides.size - 1)
        .setIn(['slider', 'nextSlide'], 1)
    }

    case LOAD_SLIDER_ERROR:
      return state.setIn(['slider', 'slides'], fromJS([])).setIn(['slider', 'loaded'], true)

    case TRANSITION_END:
      return state.setIn(['slider', 'transitioning'], false)

    case LOAD_COLLECT_HOME_SUCCESS: {
      return state.set('home', fromJS(action.data))
    }

    case LOAD_COLLECT_HOME_ERROR:
      return state

    case NEXT_SLIDE: {
      const slidesLength = state.getIn(['slider', 'slides']).size
      if (slidesLength < 2) return state

      const changesFrom = state.getIn(['slider', 'currentSlide'])
      const changesTo = changesFrom === slidesLength - 1 ? 0 : changesFrom + 1
      const nextSlide = changesTo === slidesLength - 1 ? 0 : changesTo + 1

      return state
        .setIn(['slider', 'previousSlide'], changesFrom)
        .setIn(['slider', 'nextSlide'], nextSlide)
        .setIn(['slider', 'currentSlide'], changesTo)
        .setIn(['slider', 'transitioning'], true)
    }

    case PREVIOUS_SLIDE: {
      const slidesLength = state.getIn(['slider', 'slides']).size
      if (slidesLength < 2) return state

      const changesFrom = state.getIn(['slider', 'currentSlide'])
      const changesTo = changesFrom === 0 ? slidesLength - 1 : changesFrom - 1
      const previousSlide = changesTo === 0 ? slidesLength - 1 : changesTo - 1

      return state
        .setIn(['slider', 'previousSlide'], previousSlide)
        .setIn(['slider', 'nextSlide'], changesFrom)
        .setIn(['slider', 'currentSlide'], changesTo)
        .setIn(['slider', 'transitioning'], true)
    }

    case GO_TO_SLIDE: {
      let previousSlide
      let followingSlide
      const { slideIndex } = action
      const slidesLength = state.getIn(['slider', 'slides']).size
      const changesFrom = state.getIn(['slider', 'currentSlide'])

      if (slidesLength < 2) return state
      if (slideIndex > slidesLength - 1) return state
      if (slideIndex < 0) return state
      if (slideIndex === changesFrom) return state

      if (slideIndex === 0) {
        previousSlide = slidesLength - 1
        followingSlide = 1
      } else if (slideIndex === slidesLength - 1) {
        previousSlide = slidesLength - 2
        followingSlide = 0
      } else {
        previousSlide = slideIndex - 1
        followingSlide = slideIndex + 1
      }

      return state
        .setIn(['slider', 'previousSlide'], previousSlide)
        .setIn(['slider', 'nextSlide'], followingSlide)
        .setIn(['slider', 'currentSlide'], slideIndex)
        .setIn(['slider', 'transitioning'], true)
    }

    default:
      return state
  }
}

export default homePageReducer
